import { render, staticRenderFns } from "./IrisRadioButton.vue?vue&type=template&id=6fe4f164&"
import script from "./IrisRadioButton.vue?vue&type=script&lang=ts&"
export * from "./IrisRadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./IrisRadioButton.vue?vue&type=style&index=0&id=6fe4f164&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports